// extracted by mini-css-extract-plugin
export var actionButton = "styles-module--actionButton--20785";
export var button = "styles-module--button--4c30e";
export var inlineLink = "styles-module--inlineLink--b8e21";
export var popup = "styles-module--popup--d21fc";
export var popupActions = "styles-module--popupActions--aa123";
export var popupBody = "styles-module--popupBody--08c11";
export var popupClose = "styles-module--popupClose--0dba1";
export var popupHeader = "styles-module--popupHeader--e1b78";
export var popupHeaderBrand = "styles-module--popupHeaderBrand--d3801";
export var popupLogo = "styles-module--popupLogo--e0c15";
export var popupMessage = "styles-module--popupMessage--c41d1";
export var popupSender = "styles-module--popupSender--622da";
export var popupTimestamp = "styles-module--popupTimestamp--14551";
export var popupTitle = "styles-module--popupTitle--fa3ef";